module.exports = __webpack_public_path__ + "static/media/  (80).71c16215.jpg";